// extracted by mini-css-extract-plugin
module.exports = {"medium":"SentinelPriorityMessage_medium__2_hwm","high":"SentinelPriorityMessage_high__C6i95","highest":"SentinelPriorityMessage_highest__2QKq3"};